export function objectToBase64<T>(params: T): string {
    return window.btoa(JSON.stringify(params));
}
export function base64ToObject<T>(params: string): T {
    return JSON.parse(window.atob(params));
}
